import { render, staticRenderFns } from "./typeChooseView.vue?vue&type=template&id=2ece9334&scoped=true"
import script from "./typeChooseView.vue?vue&type=script&lang=js"
export * from "./typeChooseView.vue?vue&type=script&lang=js"
import style0 from "./typeChooseView.vue?vue&type=style&index=0&id=2ece9334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece9334",
  null
  
)

export default component.exports